import { FuseNavigation } from '@fuse/types';
import * as _ from 'lodash';
const currentUser = JSON.parse(localStorage.getItem('currentUser'));
const parentModulesStore = [];
const childrens: FuseNavigation[] = parentModulesStore;
childrens.push(
    {
        id: 'dashboard',
        title: 'Dashbord',
        translate: 'NAV.SCRUMBOARD',
        type: 'item',
        icon: 'dashboard',
        url: 'apps/dashboard'
        // children: [
        //     {
        //         id: 'request-view',
        //         title: 'Request',
        //         type: 'item',
        //         url: '/apps/request-view'
        //     }
        // ]
    },
    {
        id: 'deals',
        title: 'Deals',
        translate: 'NAV.SCRUMBOARD',
        type: 'item',
        icon: 'local_offer',
        url: 'apps/deals'
    },
    {
        id: 'contacts',
        title: 'Contacts',
        translate: 'NAV.SCRUMBOARD',
        type: 'item',
        icon: 'contacts',
        url: 'apps/contacts'
    },
    {
        id: 'messgae',
        title: 'Message',
        translate: 'NAV.SCRUMBOARD',
        type: 'item',
        icon: 'message',
        url: 'apps/chats'
    }
);
if (currentUser && currentUser.role_id == 4) {
    childrens[0].children.push(
        {
            id: 'client-view',
            title: 'Client',
            type: 'item',
            url: '/apps/client-view'
        },
        {
            id: 'freelancer-view',
            title: 'Freelancer',
            type: 'item',
            url: '/apps/freelancer-view'
        });
}
export const navigation: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        icon: 'apps',
        children: childrens
    }
];